export enum Types {
	ATUALIZAR_FUNCIONALIDADE = '@SGU/ATUALIZAR_FUNCIONALIDADE',
	ATUALIZAR_FUNCIONALIDADE_SUCCESS = '@SGU/ATUALIZAR_FUNCIONALIDADE_SUCCESS',
	ATUALIZAR_FUNCIONALIDADE_FAILURE = '@SGU/ATUALIZAR_FUNCIONALIDADE_FAILURE',
	ATUALIZAR_FUNCIONALIDADE_CLEAR = '@SGU/ATUALIZAR_FUNCIONALIDADE_CLEAR',
}

export interface AtualizarFuncionalidade {
	status: number;
	data: null | FuncionalidadeData;
}

interface FuncionalidadeData {
	status: string;
	statusMensagem: string;
}

export interface AtualizarFuncionalidadeRequest {
	id?: number | string;
	descricao: string;
	localidades?: string[] | null;
	idUsuarioAutenticado?: number | string;
}
